var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 26,
    height: 31,
    fill: "#F2F2F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 14.625H27.625V17.875H24.375V14.625ZM27.625 8.125H24.375V11.375H27.625V8.125ZM17.875 24.375H21.125V21.125H17.875V24.375ZM21.125 8.125H17.875V11.375H21.125V8.125ZM17.875 17.875H21.125V14.625H17.875V17.875ZM14.625 8.125H11.375V11.375H14.625V8.125ZM14.625 14.625H11.375V17.875H14.625V14.625ZM23.6438 34.125H21.125V28.4375H17.875V34.125H8.125V4.875H30.875V17.9237C32.0287 18.0212 33.1338 18.3787 34.125 18.8988V1.625H4.875V37.375H25.8538C25.1875 36.465 24.375 35.36 23.6438 34.125ZM11.375 30.875H14.625V27.625H11.375V30.875ZM14.625 21.125H11.375V24.375H14.625V21.125ZM35.75 26.8125C35.75 31.0375 30.0625 37.375 30.0625 37.375C30.0625 37.375 24.375 31.0375 24.375 26.8125C24.375 23.725 26.975 21.125 30.0625 21.125C33.15 21.125 35.75 23.725 35.75 26.8125ZM32.0125 26.975C32.0125 26 31.0375 25.025 30.0625 25.025C29.0875 25.025 28.1125 25.8375 28.1125 26.975C28.1125 27.95 28.925 28.925 30.0625 28.925C31.2 28.925 32.175 27.95 32.0125 26.975Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkLocationPin);
export default __webpack_public_path__ + "static/media/WorkLocationPin.382e704fc38edaa2745a2a2289411d18.svg";
export { ForwardRef as ReactComponent };